module.exports = __webpack_public_path__ + "img/index-partners-banner-1.5c418f78.jpg";